import React, { useCallback } from 'react';
const Pill = ({ nursery, clearNurserySearch, passWidth }) => {
    const measureRef = useCallback((element) => {
        if (element) {
            passWidth(Math.round(element.getBoundingClientRect().width));
        }
    }, [passWidth]);
    return (React.createElement("div", { ref: measureRef, className: "search__pill nursery" },
        React.createElement("span", null, "Nursery | "),
        nursery,
        React.createElement("span", { className: "x-btn", onClick: clearNurserySearch, role: "button", "aria-label": "x", tabIndex: 0, onKeyDown: clearNurserySearch })));
};
export default Pill;
